import ResourceManager from "@/components/app/ResourceManager";
import { Badge } from "@/components/ui/badge";

const config = {
  endpoint: "lenders",
  testid: "lenders",
  singular: "Lender",
  overline: "Loan Backend",
  title: "Lender Master",
  subtitle: "Banks, NBFCs and fintech lenders with default commission rules.",
  accent: "loan",
  perms: { add: "lenders.add", edit: "lenders.edit", delete: "lenders.delete" },
  columns: [
    { key: "name", label: "Lender", render: (r) => <span className="font-medium text-zinc-900">{r.name}</span> },
    { key: "lender_id", label: "Lender ID", badge: true },
    { key: "lender_type", label: "Type" },
    { key: "default_commission_percent", label: "Comm %", render: (r) => `${r.default_commission_percent || 0}%` },
    { key: "default_gst_percent", label: "GST %", render: (r) => `${r.default_gst_percent || 0}%` },
    { key: "default_tds_percent", label: "TDS %", render: (r) => `${r.default_tds_percent || 0}%` },
    { key: "active", label: "Status", render: (r) => (
      <Badge variant="outline" className={`rounded-sm font-normal ${r.active ? "border-emerald-500 text-emerald-600" : "border-zinc-300 text-zinc-400"}`}>{r.active ? "Active" : "Inactive"}</Badge>
    )},
  ],
  fields: [
    { name: "name", label: "Bank / NBFC Name", type: "text", required: true },
    { name: "lender_type", label: "Lender Type", type: "select", options: ["Bank", "NBFC", "Fintech", "Other"].map((v) => ({ value: v, label: v })) },
    { name: "contact", label: "Contact", type: "text" },
    { name: "default_commission_percent", label: "Default Commission (%)", type: "number" },
    { name: "default_gst_percent", label: "Default GST (%)", type: "number" },
    { name: "default_tds_percent", label: "Default TDS (%)", type: "number" },
    { name: "gst_applicable", label: "GST Applicable", type: "switch" },
    { name: "active", label: "Active", type: "switch" },
    { name: "notes", label: "Notes", type: "textarea" },
  ],
};

export default function Lenders() {
  return <ResourceManager config={config} />;
}
